import React from "react";

const BunyanTextLogo = ({ height = 38, width = 183 }) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 183 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9324 17.375L24.9143 20.2693L29.8964 17.375L24.9143 14.4761L19.9324 17.375Z"
        fill="#7EC7BD"
      />
      <path
        d="M14.9458 20.2693V26.0579L19.9325 23.1636L14.9458 20.2693Z"
        fill="#7EC7BD"
      />
      <path
        d="M14.9458 8.6875V14.476L19.9325 17.3752V11.5818L14.9458 8.6875Z"
        fill="#7EC7BD"
      />
      <path
        d="M0 28.9572L4.98198 31.8515L9.96394 28.9572L4.98198 26.0581L0 28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M14.9456 37.6444V31.8511L9.96362 34.7454L14.9456 37.6444Z"
        fill="#7EC7BD"
      />
      <path
        d="M9.96362 28.9572L14.9456 26.0581L9.96362 23.1641V28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M29.8967 23.164L34.8787 20.2698L29.8967 17.3752V23.164Z"
        fill="#7EC7BD"
      />
      <path
        d="M34.8784 14.4763L39.8604 17.3754V11.582L34.8784 14.4763Z"
        fill="#7EC7BD"
      />
      <path
        d="M49.8244 17.375L44.8424 14.4761L39.8604 17.3753L44.8424 20.2693L49.8244 17.375Z"
        fill="#7EC7BD"
      />
      <path
        d="M44.8425 31.8515L49.8245 28.9572L44.8425 26.0581V31.8515Z"
        fill="#7EC7BD"
      />
      <path
        d="M19.9324 28.9572L24.9143 31.8515L29.8964 28.9572L24.9143 26.0581L19.9324 28.9572Z"
        fill="#7EC7BD"
      />
      <path
        d="M34.8784 2.89429V8.6876L39.8604 5.79332L34.8784 2.89429Z"
        fill="#7EC7BD"
      />
      <path d="M0 17.3752V23.1638L4.98198 20.2695L0 17.3752Z" fill="#7EC7BD" />
      <path
        d="M9.96414 11.582L4.98218 14.4763L9.96414 17.3754V11.582Z"
        fill="#7EC7BD"
      />
      <path
        d="M24.9145 20.2693L14.9458 14.4761V20.2693L19.9325 23.1636L24.9145 20.2693Z"
        fill="#24AE81"
      />
      <path
        d="M19.9325 5.79321L14.9458 8.6875L19.9325 11.5818V5.79321Z"
        fill="#24AE81"
      />
      <path
        d="M24.9146 14.4763L29.8965 17.3754V11.582L24.9146 14.4763Z"
        fill="#24AE81"
      />
      <path
        d="M4.98218 31.8515L9.96414 34.7458L14.9461 31.8515V26.0581L4.98218 31.8515Z"
        fill="#24AE81"
      />
      <path
        d="M29.8967 17.3753L34.8787 20.2693L39.8606 17.375L34.8787 14.4761L29.8967 17.3753Z"
        fill="#24AE81"
      />
      <path
        d="M44.8424 20.2698L39.8604 17.3752V23.164L44.8424 20.2698Z"
        fill="#24AE81"
      />
      <path
        d="M44.8425 14.4763L49.8245 17.3754V11.582L44.8425 14.4763Z"
        fill="#24AE81"
      />
      <path
        d="M49.8245 28.9574V23.1641L44.8425 26.0583L49.8245 28.9574Z"
        fill="#24AE81"
      />
      <path
        d="M29.8965 28.9574V23.1641L24.9146 26.0583L29.8965 28.9574Z"
        fill="#24AE81"
      />
      <path
        d="M19.9324 34.7458L24.9143 31.8516L19.9324 28.9573V34.7458Z"
        fill="#24AE81"
      />
      <path d="M39.8604 0L34.8784 2.89429L39.8604 5.79333V0Z" fill="#24AE81" />
      <path
        d="M4.98198 20.2693L0 23.1636V28.9568L4.98198 26.0579V20.2693Z"
        fill="#24AE81"
      />
      <path
        d="M4.98218 8.6875V14.476L9.96414 11.5818L4.98218 8.6875Z"
        fill="#24AE81"
      />
      <g clip-path="url(#clip0_2152_39952)">
        <path
          d="M58.192 15.8853C58.8515 17.0145 60.2987 17.6313 61.6367 17.6313C64.3175 17.6313 66.5712 15.5483 66.5712 12.3978C66.5712 9.24739 64.3364 7.18817 61.6367 7.18817C60.2322 7.18817 58.8515 7.78601 58.192 8.91051V2.0354H56.1091V17.3704H58.192V15.8806V15.8853ZM61.3804 9.13826C63.1028 9.13826 64.4646 10.5 64.4646 12.3694C64.4646 14.2389 63.1028 15.667 61.3804 15.667C59.6582 15.667 58.211 14.3717 58.211 12.3694C58.211 10.3671 59.8479 9.13826 61.3804 9.13826Z"
          fill="#F1F5F9"
        />
        <path
          d="M72.0229 17.6266C73.0667 17.6266 74.6609 17.0715 75.2351 15.8616V17.3704H77.3179V7.4397H75.2351V12.844C75.2351 14.9079 73.6598 15.6718 72.3644 15.6718C71.0691 15.6718 70.1107 14.6944 70.1107 13.0575V7.4397H68.0278V13.1192C68.0088 15.947 69.5176 17.6266 72.0277 17.6266H72.0229Z"
          fill="#F1F5F9"
        />
        <path
          d="M81.3891 12.0324C81.3891 9.9685 82.9643 9.22359 84.2596 9.22359C85.5549 9.22359 86.5135 10.201 86.5135 11.8189V17.3702H88.5963V11.6908C88.6153 8.86298 87.1303 7.18335 84.6203 7.18335C83.5575 7.18335 81.9632 7.73848 81.3891 8.97212V7.43957H79.3062V17.375H81.3891V12.0324Z"
          fill="#F1F5F9"
        />
        <path
          d="M90.9687 22.2006H93.1846L99.3527 7.4397H97.0942L94.2473 14.3528L91.3958 7.4397H89.1421L93.1181 16.9245L90.9687 22.2006Z"
          fill="#F1F5F9"
        />
        <path
          d="M104.259 17.6266C105.791 17.6266 107.153 16.8389 107.789 15.6907V17.3702H109.872V7.43957H107.789V8.92941C107.148 7.80016 105.791 7.18335 104.344 7.18335C101.535 7.18335 99.4287 9.4371 99.4287 12.3931C99.4287 15.349 101.664 17.6266 104.259 17.6266ZM104.582 9.13818C106.176 9.13818 107.77 10.4762 107.77 12.3931C107.77 14.3099 106.28 15.6669 104.619 15.6669C102.873 15.6669 101.535 14.1771 101.535 12.3931C101.535 10.6091 102.873 9.13818 104.577 9.13818H104.582Z"
          fill="#F1F5F9"
        />
        <path
          d="M113.929 12.0324C113.929 9.9685 115.504 9.22359 116.799 9.22359C118.094 9.22359 119.053 10.201 119.053 11.8189V17.3702H121.136V11.6908C121.155 8.86298 119.67 7.18335 117.16 7.18335C116.097 7.18335 114.503 7.73848 113.929 8.97212V7.43957H111.846V17.375H113.929V12.0324Z"
          fill="#F1F5F9"
        />
        <path
          d="M58.3154 23.5292L59.6677 25.1992L61.3568 23.8708C61.3568 23.8708 60.6593 22.9408 60.0283 22.1816C59.0793 22.7083 58.3202 23.5339 58.3202 23.5339L58.3154 23.5292Z"
          fill="#F1F5F9"
        />
        <path
          d="M62.581 25.4084C63.0223 26.8034 63.2785 28.1937 63.2785 29.3988C63.2785 30.3477 63.1314 31.2777 62.8752 31.9752C62.2441 32.4402 61.5466 32.5873 60.6357 32.5873C58.7758 32.5873 57.6607 31.7427 57.6607 29.7166C57.6607 28.9148 57.8078 28.132 57.9976 27.4772C57.4045 27.2874 56.9206 27.183 56.3085 27.183C56.057 28.0276 55.8245 28.9338 55.8245 30.1389C55.8245 33.0949 57.3238 34.6987 60.2798 34.6987C61.9689 34.6987 63.193 34.1293 63.976 33.1566C64.7778 32.184 65.1574 30.604 65.1812 29.0382C65.1812 27.5816 65.0341 25.9778 64.7161 24.6445C63.9333 24.7062 63.1741 24.9814 62.5857 25.4037L62.581 25.4084Z"
          fill="#F1F5F9"
        />
        <path
          d="M107.092 33.8964C106.84 33.5359 106.418 33.0091 106.038 32.5679C105.089 33.0945 104.33 33.9201 104.33 33.9201L105.682 35.5903L107.352 34.2617L108.43 35.5903L110.119 34.2617C110.119 34.2617 109.421 33.3128 108.79 32.5727C107.946 33.0376 107.248 33.754 107.101 33.9011L107.092 33.8964Z"
          fill="#F1F5F9"
        />
        <path
          d="M112.287 21.1234L113.639 22.7936L115.328 21.465C115.328 21.465 114.631 20.5351 114 19.7759C113.051 20.3026 112.292 21.1281 112.292 21.1281L112.287 21.1234Z"
          fill="#F1F5F9"
        />
        <path
          d="M117.207 33.9393L118.559 35.6094L120.248 34.2809C120.248 34.2809 119.551 33.3319 118.92 32.5918C117.972 33.1184 117.212 33.944 117.212 33.944L117.207 33.9393Z"
          fill="#F1F5F9"
        />
        <path
          d="M120.861 23.1732C120.12 23.1922 119.172 23.5766 118.664 23.9324C119.086 24.9667 119.361 26.2146 119.361 27.1825C119.361 27.5432 119.342 27.8374 119.233 28.2169H116.804C115.708 28.2169 114.968 28.1742 114.356 27.9227C114.759 27.0354 115.096 25.9394 115.348 24.796C114.797 24.5208 114.038 24.3737 113.151 24.4163C112.98 25.854 112.747 26.9311 112.202 28.2169H110.683C109.502 28.2169 108.591 28.1552 107.941 27.9227C108.344 27.0354 108.7 25.9394 108.956 24.796C108.387 24.5208 107.647 24.3547 106.759 24.4163C106.57 25.854 106.337 26.9311 105.811 28.2169H70.3768C70.3768 28.2169 70.372 28.2169 70.3673 28.2169C70.3673 28.2169 70.3625 28.2169 70.3578 28.2169H68.7304V18.4712C67.6343 18.4712 66.9131 18.7227 66.301 19.1259C66.5762 23.4769 66.8087 26.7366 66.9749 30.4754H70.3625C70.3625 30.4754 70.3673 30.4754 70.372 30.4754H106.627C106.878 30.1385 107.068 29.8016 107.386 29.2086C108.059 30.0673 109.25 30.4706 110.655 30.4754H113.041C113.293 30.1385 113.483 29.8016 113.782 29.2086C114.451 30.0673 115.584 30.4706 116.775 30.4754H120.576C121.041 29.2275 121.273 27.6903 121.273 26.4234C121.273 25.4935 121.145 24.1839 120.852 23.1732H120.861Z"
          fill="#F1F5F9"
        />
      </g>
      <defs>
        <clipPath id="clip0_2152_39952">
          <rect
            width="127.175"
            height="33.574"
            fill="white"
            transform="translate(55.8245 2.0354)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BunyanTextLogo;
